export default {
  absoluteY: 1214,
  absoluteX: 76,
  boxes: [
    {
      type: "primaryBox",
      x: 471,
      y: 135,
      strokeColor: "cyan5",
      hoverColor: "cyan0",
      text: "User Experience",
    },
    {
      type: "multiBox",
      x: 0,
      y: 0,
      width: 207,
      height: 198,
      fillColor: "cyan0",
      text: "Discover",
    },
    {
      type: "multiBox",
      x: 0,
      y: 220,
      width: 207,
      height: 108,
      fillColor: "cyan0",
      text: "Define",
    },
    {
      type: "multiBox",
      x: 0,
      y: 350,
      width: 207,
      height: 243,
      fillColor: "cyan0",
      text: "Ideate",
    },
    {
      type: "multiBox",
      x: 255,
      y: 395,
      width: 207,
      height: 198,
      fillColor: "cyan0",
      text: "Prototype",
    },
    {
      type: "multiBox",
      x: 510,
      y: 485,
      width: 207,
      height: 108,
      fillColor: "cyan0",
      text: "Test and Iterate",
    },
    {
      type: "multiBox",
      x: 890,
      y: 0,
      width: 238,
      height: 153,
      fillColor: "cyan0",
      text: "Interaction Design",
    },
    {
      type: "multiBox",
      x: 890,
      y: 175,
      width: 238,
      height: 198,
      fillColor: "cyan0",
      text: "Visual Design",
    },

    {
      type: "tertiaryBox",
      x: 16,
      y: 57,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Personas",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 102,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Empathy Map",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 147,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Customer Journey Map",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 277,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Problem Statement",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 407,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Brainstorming",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 452,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Information Architecture",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 497,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "User Flow",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 542,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Mind Map",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 271,
      y: 452,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Sketching",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 271,
      y: 497,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Wireframing",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 271,
      y: 542,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Prototyping",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 526,
      y: 542,
      width: 175,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Usability Test",
      hoverColor: "cyan1",
    },

    {
      type: "tertiaryBox",
      x: 906,
      y: 57,
      width: 206,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Human-Computer Interaction",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 906,
      y: 102,
      width: 206,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Cognitive Psychology",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 906,
      y: 232,
      width: 206,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Basics & Principles",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 906,
      y: 277,
      width: 206,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Gestalt Principles",
      hoverColor: "cyan1",
    },
    {
      type: "tertiaryBox",
      x: 906,
      y: 322,
      width: 206,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Visual Hierarchy",
      hoverColor: "cyan1",
    },

    {
      type: "secondaryBox",
      x: 934,
      y: 412,
      width: 150,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "Jobs-to-be-Done",
      hoverColor: "cyan1",
    },
    {
      type: "secondaryBox",
      x: 934,
      y: 466,
      width: 150,
      fillColor: "cyan0",
      strokeColor: "cyan3",
      text: "User Story",
      hoverColor: "cyan1",
    },
    {
      type: "secondaryBox",
      x: 284,
      y: 189,
      width: 150,
      fillColor: "cyan0",
      strokeColor: "cyan4",
      text: "Design Thinking",
      hoverColor: "cyan1",
    },
    {
      type: "secondaryBox",
      x: 934,
      y: 520,
      width: 150,
      fillColor: "cyan0",
      strokeColor: "cyan4",
      text: "UX Benchmarking",
      hoverColor: "cyan1",
    },
    {
      type: "secondaryBox",
      x: 285,
      y: 28,
      width: 150,
      fillColor: "cyan0",
      strokeColor: "cyan4",
      text: "Content Strategy",
      hoverColor: "cyan1",
    },
    {
      type: "secondaryBox",
      x: 285,
      y: 82,
      width: 150,
      fillColor: "cyan0",
      strokeColor: "cyan4",
      text: "UX Storytelling",
      hoverColor: "cyan1",
    },
  ],
};
